import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { useI18n } from "../lib/i18n";
import { useAuth } from "../lib/auth";
import { formatApiErrorDetail } from "../lib/api";
import { AuthField } from "./Login";

export default function Register() {
    const { t } = useI18n();
    const { register } = useAuth();
    const nav = useNavigate();
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [busy, setBusy] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setBusy(true);
        try {
            await register(email, password, name);
            nav("/dashboard", { replace: true });
        } catch (err) {
            setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="bg-grain min-h-screen">
            <Navbar />
            <div className="max-w-md mx-auto px-4 py-20" data-testid="register-page">
                <h1 className="font-display text-4xl">{t.auth.registerTitle}</h1>
                <p className="text-brand-text/70 mt-2">{t.auth.registerSub}</p>
                <form onSubmit={submit} className="mt-8 space-y-4 rounded-3xl border border-brand-border bg-white p-7">
                    <AuthField label={t.auth.name} value={name} onChange={setName} testid="register-name" />
                    <AuthField label={t.auth.email} type="email" value={email} onChange={setEmail} testid="register-email" required />
                    <AuthField label={t.auth.password} type="password" value={password} onChange={setPassword} testid="register-password" required />
                    {error && <div className="text-sm text-brand-critical" data-testid="register-error">{error}</div>}
                    <button disabled={busy} type="submit" className="w-full py-3 rounded-full btn-primary font-semibold disabled:opacity-60" data-testid="register-submit">
                        {busy ? "..." : t.auth.register}
                    </button>
                    <div className="text-sm pt-2 text-brand-textMuted text-center">
                        {t.auth.hasAccount} <Link to="/login" className="text-brand-primary" data-testid="register-to-login">{t.auth.login}</Link>
                    </div>
                </form>
            </div>
        </div>
    );
}
